// extracted by mini-css-extract-plugin
export default {"expert":"Expert_expert__N9Lrx","information":"Expert_information__X9Hio","boxes":"Expert_boxes__hbtlE"};